import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataProcess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={434}
    height={286}
    fill="none"
    viewBox="-10 0 448 286"
    {...props}
  >
    <defs>
      <linearGradient
        id="DataProcess_svg__a"
        x1={-19.974}
        x2={142.157}
        y1={9.313}
        y2={290.132}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.036} stopColor="#B6B4FF" />
        <stop offset={0.063} stopColor="#C5C6D6" stopOpacity={0.63} />
        <stop offset={0.146} stopColor="#C5C6D6" stopOpacity={0.5} />
        <stop offset={0.245} stopColor="#BDBCFF" />
        <stop offset={0.328} stopColor="#C5C6D6" stopOpacity={0.55} />
        <stop offset={0.521} stopColor="#C5C6D6" stopOpacity={0.683} />
        <stop offset={0.542} stopColor="#BCBBFF" />
        <stop offset={0.682} stopColor="#C5C6D6" stopOpacity={0.58} />
        <stop offset={0.682} stopColor="#B9B7FF" />
        <stop offset={0.811} stopColor="#C5C6D6" stopOpacity={0.63} />
        <stop offset={0.91} stopColor="#B7B5FF" />
        <stop offset={1} stopColor="#C5C6D6" stopOpacity={0.49} />
      </linearGradient>
      <linearGradient
        id="DataProcess_svg__d"
        x1={272.508}
        x2={272.508}
        y1={146}
        y2={243.649}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.115} stopColor="#F7DB71" stopOpacity={0} />
        <stop offset={1} stopColor="#FFD600" stopOpacity={0.77} />
      </linearGradient>
      <linearGradient
        id="DataProcess_svg__e"
        x1={5.477}
        x2={76.684}
        y1={65.729}
        y2={-3.521}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1BE01" />
        <stop offset={1} stopColor="#FFD435" />
      </linearGradient>
      <linearGradient
        id="DataProcess_svg__f"
        x1={170.643}
        x2={157.708}
        y1={24.062}
        y2={89.088}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F7DB71" />
        <stop offset={1} stopColor="#FFECA3" />
      </linearGradient>
      <radialGradient id="DataProcess_svg__b" cx={0} cy={0} r={1}>
        <stop offset="0%" stopColor="#F3C107" />
        <stop offset="100%" stopColor="#FEE999" />
      </radialGradient>
      <radialGradient id="DataProcess_svg__c" cx={0} cy={0} r={1}>
        <stop offset={0} stopColor="#6551FF" />
        <stop offset="100%" stopColor="#D4D3FC" />
      </radialGradient>
    </defs>
    <path
      stroke="url(#DataProcess_svg__a)"
      strokeLinecap="round"
      strokeWidth={1.372}
      d="M181.353 39.83 64.952 107.034 2 143.379l78.393 45.26 114.026-65.832 53.449 30.859-51.074 29.487 65.328 37.717 147.283-85.034L257.37 48.059l-67.702 39.088-19.005-10.972"
    />
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="M143.96 41.642c-.81 3.379-5.173 5.668-9.938 5.033-4.764-.635-7.804-3.929-7.136-7.39.81-3.378 5.173-5.668 9.937-5.033 4.765.636 7.805 3.93 7.137 7.39"
      clipRule="evenodd"
    />
    <circle r={10} fill="url(#DataProcess_svg__b)">
      <animateMotion
        dur="7s"
        path="M181.353 39.8298L64.9518 107.034L2 143.379L80.3928 188.639L194.419"
        repeatCount="indefinite"
      />
    </circle>
    <circle r={8} fill="url(#DataProcess_svg__c)">
      <animateMotion
        dur="12s"
        path="M181.353 39.8298L64.9518 107.034L2 143.379L80.3928 188.639L194.419 122.807L247.868 153.666L196.794 183.153L262.122 220.87L409.405 135.836L257.37 48.0589L189.668 87.1471L170.663 76.175"
        repeatCount="indefinite"
      />
    </circle>
    <path
      fill="#F6F6F9"
      d="m61.311 239.16 19.385-11.361 19.385 10.793-19.385 11.361z"
    />
    <path
      fill="#D4D3FF"
      d="m65.004 179.477 15.693-9.231 15.693 8.769-15.693 9.231z"
    />
    <path fill="#B0AEFF" d="M65.004 179.477v18.462l15.693 9.231v-18.924z" />
    <path fill="#948BFF" d="m80.697 188.247 15.693-9.231v18.554l-15.693 9.6z" />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="m206.042 233.586-.009-3.412s66.541-34.789 67.038-34.505l66.213 35.15v2.92s0 .646-.646.968l-65.035 37.505c-.497.284-1.278.284-1.775 0l-65.395-38.2c-.497-.284-.391-.426-.391-.426"
      clipRule="evenodd"
    />
    <path
      fill="#F6F6F9"
      fillRule="evenodd"
      d="m206.355 229.529 65.541-37.214c.497-.284 1.278-.284 1.776 0l65.281 37.859c.497.284.497.746 0 1.03l-64.713 37.193c-.497.284-1.279.284-1.776 0l-66.073-37.839c-.497-.284-.533-.745-.036-1.029"
      clipRule="evenodd"
    />
    <path
      fill="url(#DataProcess_svg__d)"
      d="M244.331 146h56.355v86.841s-6.969 10.808-28.178 10.808-28.177-10.808-28.177-10.808z"
    />
    <path
      fill="#F3F2FF"
      fillRule="evenodd"
      d="M283.439 227.378c.441 0 .779.121.779.259 0 .139-.338.26-.779.26-.44 0-.778-.121-.778-.26 0-.138.338-.259.778-.259"
      clipRule="evenodd"
    />
    <path
      fill="#F1BE01"
      d="M253.326 180.783a1.61 1.61 0 0 1 .397-2.07l.849-.67a1.61 1.61 0 0 1 2.393.459l1.034 1.791c.491.85.113 1.939-.799 2.302l-1.005.4a1.61 1.61 0 0 1-1.991-.691z"
    />
    <path
      fill="#F7DB71"
      d="M275.72 159.643a.532.532 0 0 1 .741.548l-.654 5.776a.533.533 0 0 1-.846.368l-4.674-3.455a.532.532 0 0 1 .104-.916zM291.366 188.779a.532.532 0 0 1 .175.905l-2.807 2.436a.532.532 0 0 1-.872-.301l-.706-3.649a.532.532 0 0 1 .696-.604z"
    />
    <path
      fill="#F4CD39"
      d="M268.907 206.237a.532.532 0 0 1 .917.097l2.417 5.437a.532.532 0 0 1-.542.746l-5.918-.626a.532.532 0 0 1-.374-.842z"
    />
    <circle cx={269.885} cy={188.057} r={2.129} fill="#FAE9A9" />
    <circle cx={260.834} cy={199.77} r={1.597} fill="#F1BE01" />
    <circle cx={291.712} cy={175.737} r={2.129} fill="#F4CD39" />
    <circle cx={283.195} cy={202.431} r={4.259} fill="#F1BE01" opacity={0.2} />
    <circle cx={283.195} cy={202.431} r={2.242} fill="#F1BE01" />
    <ellipse cx={411.533} cy={146.306} fill="#D4D3FF" rx={22.084} ry={7.563} />
    <ellipse cx={411.533} cy={131.18} fill="#D4D3FF" rx={22.084} ry={7.563} />
    <path
      fill="#D4D3FF"
      d="M389.449 115.751h44.167v30.252s-3.025 7.865-21.781 7.865-22.386-7.865-22.386-7.865z"
      opacity={0.7}
    />
    <ellipse cx={411.533} cy={116.053} fill="#F3F2FF" rx={22.084} ry={7.563} />
    <ellipse cx={411.533} cy={180.284} fill="#F6F6F9" rx={22.084} ry={7.563} />
    <rect
      width={70.424}
      height={65.694}
      fill="url(#DataProcess_svg__e)"
      rx={6.307}
      transform="matrix(.86603 -.5 0 1 131 35.212)"
    />
    <path
      fill="url(#DataProcess_svg__f)"
      fillRule="evenodd"
      d="M161.834 48.71c4.678-2.701 8.47-9.27 8.47-14.672s-3.792-7.591-8.47-4.89c-4.679 2.7-8.471 9.27-8.471 14.671 0 5.402 3.792 7.592 8.471 4.89m15.924 12.715-32.527 18.78c0-10.372 7.281-22.984 16.264-28.17 8.982-5.185 16.263-.981 16.263 9.39"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataProcess;
